import { render, staticRenderFns } from "./registrations.vue?vue&type=template&id=4a90a778&scoped=true&"
import script from "./registrations.vue?vue&type=script&lang=js&"
export * from "./registrations.vue?vue&type=script&lang=js&"
import style0 from "./registrations.vue?vue&type=style&index=0&id=4a90a778&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90a778",
  null
  
)

export default component.exports